const EncodeToBase64 = (username, password) => {
    const credentials = `${username}:${password}`;
    const encoded = btoa(credentials);
    return encoded;
  };
  
export default EncodeToBase64;
